import styled, { css } from 'styled-components';
import { InputBaseCSS, InputErrorMessageCSS, InputLabelCSS, InputRequiredAsteriskCSS, InputWrapperCSS, } from '../common/index.js';
export const IconTextInputWrapper = styled.div `
  ${InputWrapperCSS}
`;
export const InputLabel = styled.label `
  ${InputLabelCSS}
`;
export const RequiredAsterisk = styled(InputLabel) `
  ${InputRequiredAsteriskCSS}
`;
export const InputWrapper = styled.div `
  display: flex;
  position: relative;
`;
export const IconWrapper = styled.div `
  height: 100%;
  width: 38px;
  display: flex;
  font-size: 14px;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  ${({ isFocused }) => isFocused &&
    css `
      color: #342a6a;
    `};
`;
export const TextInput = styled.input `
  ${InputBaseCSS};
  padding: 0 32px 0 14px;
`;
export const InputErrorMessage = styled.p `
  ${InputErrorMessageCSS}
`;
//# sourceMappingURL=BKJDollarTextInput.styled.js.map